import Model from '@/shared/models/plans/PlanPackageModule'

export default class PlanPackageModule extends Model {}
